import { viewFor, type Surface } from '@littlebird/action-cards-view';

import type { ActionCard } from '@littlebird/sdk';

// False for a row from a pod that has not shipped this surface's document yet
export const hasViewFor = (card: ActionCard, surface: Surface): boolean =>
  viewFor(card.views, surface) !== undefined;
